var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalDataCollectionFree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#475EFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2 15.6452L17.0972 24.4988C16.7585 25.4651 15.8515 26.1113 14.834 26.1113H10.6C9.71634 26.1113 9 25.3899 9 24.5C9 23.6101 9.71634 22.8887 10.6 22.8887H14.268L18.314 11.3438C18.942 9.55205 21.4581 9.55208 22.086 11.3438L29.8 33.3548L32.9028 24.5012C33.2415 23.5349 34.1485 22.8887 35.166 22.8887H39.4C40.2837 22.8887 41 23.6101 41 24.5C41 25.3899 40.2837 26.1113 39.4 26.1113H35.732L31.686 37.6562C31.058 39.4479 28.542 39.4479 27.914 37.6562L20.2 15.6452Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalDataCollectionFree);
export default __webpack_public_path__ + "static/media/total-data-collection-free.db29ce7294d771e7bc53bfae8b9dbba6.svg";
export { ForwardRef as ReactComponent };